import { post, getClubMed, postClubMed } from './fetcher'
import { RESORT_KEY } from './constants'

const kindFilter = {
  kinds: ['CC']
}

export const currentResort = () => {
  return window.localStorage[RESORT_KEY]
}

export const fetchResorts = () => {
  return getClubMed('/api/resorts')
}

export const authenticate = (resort, login, password) => {
  return postClubMed('/api/login', { resort, login, password })
}

export const verifyToken = token => {
  return postClubMed('/api/verify', { token })
}

export const fetchWelcome = (intermediary, resort, lang) => {
  return post('/api/welcome', { intermediary, resort, lang })
}

export const fetchStays = (intermediary, resort, lang, season) => {
  const payload = { intermediary, resort, lang, season }
  return post('/api/vel3/stays', payload)
}

export const fetchAges = (
  intermediary,
  resort,
  lang,
  season,
  stayFrom,
  stayTo
) => {
  const context = { intermediary, resort, lang, season }
  const stay = { stayFrom, stayTo }
  const payload = { ...context, ...stay, ...kindFilter }
  return post('/api/vel3/ages', payload)
}

export const fetchActivities = (
  intermediary,
  resort,
  lang,
  season,
  stayFrom,
  stayTo,
  birthday
) => {
  const context = { intermediary, resort, lang, season }
  const stay = { stayFrom, stayTo }
  const payload = { ...context, ...stay, ...kindFilter, birthday }
  return post('/api/vel3/activities', payload)
}

export const fetchLevels = (
  intermediary,
  resort,
  lang,
  season,
  stayFrom,
  stayTo,
  birthday,
  activity
) => {
  const context = { intermediary, resort, lang, season }
  const stay = { stayFrom, stayTo }
  const activities = [activity]
  const payload = { ...context, ...stay, ...kindFilter, birthday, activities }

  return post('/api/vel3/levels', payload)
}

export const fectchProducts = (
  intermediary,
  resort,
  lang,
  season,
  stayFrom,
  stayTo,
  birthday,
  activity,
  level
) => {
  const context = { intermediary, resort, lang, season }
  const stay = { stayFrom, stayTo }
  const activities = [activity]
  const levels = [level]
  const payload = {
    ...context,
    ...stay,
    ...kindFilter,
    birthday,
    activities,
    levels
  }

  return post('/api/vel3/products', payload)
}

export const fetchPrestations = (
  intermediary,
  resort,
  lang,
  season,
  stayFrom,
  stayTo,
  birthday,
  activity,
  level,
  product
) => {
  const context = { intermediary, resort, lang, season }
  const stay = { stayFrom, stayTo }
  const activities = [activity]
  const levels = [level]
  const payload = {
    ...context,
    ...stay,
    ...kindFilter,
    birthday,
    activities,
    levels,
    product
  }

  return post('/api/vel3/prestations', payload)
}

export const validation = (
  token,
  intermediary,
  resort,
  lang,
  season,
  stayFrom,
  stayTo,
  birthday,
  activity,
  level,
  product,
  prestationCode,
  meeting,
  language,
  firstname,
  lastname,
  room,
  phone
) => {
  const headers = { 'X-CLUBMED-TOKEN': token }
  const context = { intermediary, resort, lang, season }
  const stay = { stayFrom, stayTo }
  const activities = [activity]
  const levels = [level]
  const prestations = [
    { product: prestationCode, rdv: meeting, lang: language }
  ]
  const identification = {
    title: '0',
    firstname,
    lastname,
    room,
    phone,
    comment: `room: ${room}, tel: ${phone}`
  }
  const spoken = lang

  const payload = {
    ...context,
    ...stay,
    ...kindFilter,
    birthday,
    activities,
    levels,
    product,
    prestations,
    ...identification,
    spoken
  }

  return postClubMed('/api/validate', payload, headers)
}



// WEBPACK FOOTER //
// ./src/services/api.js